import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getListUserDistribution({ commit }, id) {
      try {
        const response = await api.get(`/distributions/${id}/users`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getUserDistribution({ commit }, data) {
      try {
        const response = await api.get(
          `/distributions/${data.id}/users/${data.uuid}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateUserDistribution({ commit }, data) {
      try {
        const response = await api.put(
          `/distributions/${data.id}/users/${data.uuid}`,
          data.userDistribution,
        )
        return response
      } catch (error) {
        throw error
      }
    },

    async createAnalisys({ commit }, data) {
      try {
        const response = await api.post(
          `/distributions/${data.id}/users/${data.uuid}/analisys`,
          data.userDistribution,
        )
        return response
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
